if(!customElements.get('hero-slider')) {
  customElements.define(
    'hero-slider',
    class HeroSlider extends HTMLElement {
      sliderEl = null;
      sliderInstance = null;
      
      constructor() {
        super();
      }
      
      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if(!this.sliderEl) {
          return console.error('An error ocurred while trying to initialize Hero Slider. No slider element was found.')
        }

        this.sliderInstance = new Swiper(this.sliderEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            prevEl: '.hero-slider-button.slider-button.prev',
            nextEl: '.hero-slider-button.slider-button.next',
          },
          pagination: {
            el: '.hero-slider-pagination',
            type: 'bullets',
            clickable: true
          }
        });
      }
    }
  );
}
